function toggleMobileMenu() {
  document.body.classList.toggle('site-mobile-menu-open')
}

function handleResize() {
  if (window.innerWidth > 1280) {
    document.body.classList.remove('site-mobile-menu-open')
  }
}

function initMobileMenu() {
  document
    .querySelector('[data-js="SiteMobileMenuToggle"]')
    ?.addEventListener('click', toggleMobileMenu)

  window.addEventListener('resize', handleResize)
  handleResize()
}

export default initMobileMenu
